import React,{useState} from 'react'
import {useHistory} from 'react-router-dom'
import {motion} from "framer-motion";
import image0 from "../images/Resume0-page-001.jpg"
import image1 from "../images/Resume1-page-001.jpg"
import image2 from "../images/Resume2-page-001.jpg"
import image3 from "../images/Resume3-page-001.jpg"
import image4 from "../images/Resume4-page-001.jpg"
import image5 from "../images/Resume5-page-001.jpg"

const contVariant={
  hidden:{
    opacity:0
  },
  visible:{
    opacity:1,
    transition:{
      duration:0.5
    }
  }
}
const linkVariant={
  hover:{
  	scale:1.5,
    textShadow: "2px 2px 10px rgba(0,0,0,0.8)",
    boxShadow:"2px 2px 10px rgba(0,0,0,0.8)",
    transition:{
      duration:0.2
    }
  }
}
export default function Templates() {
	const images=[image0,image1,image2,image3,image4,image5]
	const [showOverlay,setShowOverlay]=useState(false)
	const [imagePointer,setImagePointer]=useState(0)
	const history=useHistory()
	function handleTemplateSelection(){
		history.push(`/preview-template/${imagePointer}`)
	}
	function nextImage(){
		setImagePointer(prevPointer=>{
			return (prevPointer+1)%images.length
		})
	}
	function prevImage(){
		setImagePointer(prevPointer=>{
			if(prevPointer>0)
				return (prevPointer-1)
			return images.length-1
		})
	}
	return (
		<motion.div className="container" style={{flexDirection:"column"}} exit={{opacity:0}}
        	variants={contVariant}
        	initial="hidden"
        	animate="visible"
		>
			<h1 style={{textShadow:"2px 2px 5px rgba(0,0,0,0.8)"}}>Choose Template</h1>
			<div className="img-grid-container" onMouseEnter={()=>setShowOverlay(true)} onMouseLeave={()=>setShowOverlay(false)}>
				<img className="img-grid-item" src={images[imagePointer]} />
				<div className={`overlay ${!showOverlay ? 'hide-overlay' : ''}`}>
					<motion.button variants={linkVariant} whileHover="hover" className="overlay-btn" onClick={handleTemplateSelection}>Preview</motion.button>
				</div>
			</div>
			<div>
				<button  style={{color:"white",outline:"none"}} onClick={prevImage} ><i class="fas fa-arrow-left"></i></button>
				<button  style={{color:"white",outline:"none"}} onClick={nextImage} ><i class="fas fa-arrow-right"></i></button>
			</div>
		</motion.div>
	)
}